import { useQuery } from '@apollo/client';
import { Link } from 'react-router';
import { ApolloProviderV4 } from '~/apollo/client-v4';
import { graphql } from '~/apollo/generated/v4';
import { Heading } from '~/components/common/Heading';
import { SpinnerPlaceholder } from '~/components/common/SpinnerPlaceholder';
import { useBreadcrumb } from '~/components/layout/Breadcrumb';
import { Button } from '~/components/ui/button';
import { Menu } from '~/components/ui/menu';
import { CreateVftForm } from '~/components/upload/vft/create-vft-form';
import { UpdateVftModal } from '~/components/upload/vft/update-vft-modal';
import { uploadVftIdRoute } from '~/paths';
import type { VftManagerPageQueryQuery as VftManagerPageType } from '~/apollo/generated/v4/graphql';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPencil } from '@fortawesome/free-solid-svg-icons';

const vftManagerPageQuery = graphql(`
  query vftManagerPageQuery {
    virtualFieldTripList {
      results {
        id
        lifecycleStatus
        name
        outcropTour
        outcrops {
          id
          name
        }
      }
    }
  }
`);
export type VftListType = NonNullable<
  VftManagerPageType['virtualFieldTripList']
>;
export type VftManagerVftType = NonNullable<VftListType['results']>[number];
export default function VftManagerPage() {
  useBreadcrumb('routes/upload/vft-manager', 'VFT Manager');

  return (
    <ApolloProviderV4>
      <InnerPage />
    </ApolloProviderV4>
  );
}

function InnerPage() {
  const { data, loading } = useQuery(vftManagerPageQuery);
  const vfts = data?.virtualFieldTripList?.results;

  return (
    <div className="grid lg:grid-cols-4 gap-6">
      <SpinnerPlaceholder show={loading} />
      <div className="space-y-4">
        <Heading level={2}>Virtual Field Trips</Heading>
        <div>
          {vfts &&
            vfts.map(vft => {
              return (
                <div key={`vft-m-${vft.id}`}className={'flex justify-between'}>
                  <Link
                    key={vft.id}
                    to={uploadVftIdRoute(Number(vft.id))}
                    className="text-muted hover:text-primary ml-1 text-sm"
                  >
                    {vft.id} - {vft.name}
                  </Link>
                  <UpdateVftModal vft={vft}>
                    {showModal => (
                      <Button
                        type="button"
                        color="ghost"
                        size="sm"
                        onClick={showModal}
                        className="ml-2"
                      >
                        <FontAwesomeIcon icon={faPencil} />
                      </Button>
                    )}
                  </UpdateVftModal>
                </div>
              );
            })}
        </div>
      </div>
      <div className="lg:col-span-3">
        <CreateVftForm />
      </div>
    </div>
  );
}
